/* eslint-disable no-throw-literal */
(() => {
  class BuyButton extends HTMLElement {
    constructor() {
      super();
      this.cartOpener = null;
      this.cartDrawer = null;
      this.buyButton = null;
      this.variantID = null;
      this.moduleClassification = null;
    }

    connectedCallback() {
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.buyButton = this.querySelector("button");
      this.variantID = this.getAttribute("data-variant-id");
      this.moduleClassification = this.getAttribute("data-module-classification");
      this.categories = this.getAttribute("data-item-categories");
      this.buyButton.addEventListener("click", async (e) => {
        e.preventDefault();
        const qty = this.getQuantity();
        this.addToCart(qty);
      });
      if(this.parentElement.querySelector("quantity-selector")){
        this.parentElement.addEventListener("changeQuantity", (e) => {
          if(e.target === this.parentElement.querySelector("quantity-selector")){
            this.handleQuantityUpdate(e.detail.state);    
          }
        });
      }
    }

    handleQuantityUpdate(state) {
      if(!state.hasCorrectQuantity){
        showErrorBox(state.message,this.parentElement,"buy-button__error-box--show","buy-button__error-box--remove");
        const box = this.querySelector(".box");
        requestAnimationFrame(() => {
          setTimeout(() => {
            box.classList.add('buy-button__error-box--remove');
            box.classList.remove('buy-button__error-box--show');
          }, 3000);
        });
  
      }
    }

    getQuantity() {
      const minQuantity = parseInt(this.getAttribute("min-quantity"));
      if(minQuantity > 1){
        return minQuantity;
      }
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      if (qtySelector) {
        return qtySelector.querySelector(".js-qty-input").value;
      }
      return 1;
    }

    async addToCart(qty) {
      this.cartOpener.click();
      this.querySelector(".loading__spinner")?.classList?.remove("hidden");
      this.buyButton.setAttribute("aria-disabled", true);
      const formData = {
        items: [
          {
            id: this.variantID,
            quantity: qty,
            properties: {
              _moduleClassification: this.moduleClassification,
              _categories: this.categories
            },
          },
        ],
      };
      this.cartDrawer.addToCart(formData).finally(() => {
        this.querySelector(".loading__spinner")?.classList.add("hidden");
        this.buyButton.setAttribute("aria-disabled", false);
      });
    }
  }

  customElements.define("buy-button", BuyButton);
})();
